import { Injectable } from '@angular/core';
import {BehaviorSubject, of, Subject} from 'rxjs';
import { SanitizeService } from './sanitize.service';
import { TenantService } from '@syntonize/merlin-core';
import {catchError, tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class InitialDataService {

  enabledModules: BehaviorSubject<any> = new BehaviorSubject([]);
  enabledModules$ = this.enabledModules.asObservable();

  logo: BehaviorSubject<any> = new BehaviorSubject([]);
  logo$ = this.logo.asObservable();

  seoTitle: BehaviorSubject<string> = new BehaviorSubject('');
  seoTitle$ = this.seoTitle.asObservable();

  seoDescription: BehaviorSubject<string> = new BehaviorSubject('');
  seoDescription$ = this.seoDescription.asObservable();

  footerLogo: BehaviorSubject<any> = new BehaviorSubject([]);
  footerLogo$ = this.footerLogo.asObservable();

  favicon: Subject<any> = new Subject();
  favicon$ = this.favicon.asObservable();

  newsletterConfiguration: BehaviorSubject<any> = new BehaviorSubject([]);
  newsletterConfiguration$ = this.newsletterConfiguration.asObservable();

  address: BehaviorSubject<any> = new BehaviorSubject([]);
  address$ = this.newsletterConfiguration.asObservable();

  cookies: Subject<any> = new Subject();
  cookies$ = this.cookies.asObservable();

  tenant: BehaviorSubject<any> = new BehaviorSubject([]);
  tenant$ = this.tenant.asObservable();

  publicName: BehaviorSubject<any> = new BehaviorSubject([]);
  publicName$ = this.publicName.asObservable();

  constructor(
      public tenantService: TenantService,
      private sanitizeService: SanitizeService,
      ) {
  }

  async getInitialData(language: string) {
    this.tenantService.getTenant().pipe(
        tap((initialData: any) => {
          this.enabledModules.next(initialData.enabledModules?.filter(module => module.isVisible) ?? []);
          this.logo.next(initialData.logo);
          this.seoTitle.next(initialData.centerTab?.seo?.[language]?.title);
          this.seoDescription.next(initialData.centerTab?.seo?.[language]?.description);
          this.footerLogo.next(initialData.footerLogo);
          this.address.next(initialData.centerTab?.dataSheet);
          this.favicon.next(initialData.favicon);
          this.cookies.next(this.sanitizeService.sanitizeString(initialData.cookiePolicy?.cookiesAcceptanceDisclaimer));
          this.newsletterConfiguration.next(initialData.contentNewsletterSubscription);
          this.tenant.next(initialData);
          this.publicName.next(initialData.publicName);
        }),
        catchError((error) => {
          console.error('Error loading tenant data:', error);
          return of(null);
        })
    ).subscribe();
  }
}
